const GlobalConfig = {
    opsda_app: 'pas_lf',
    rart_app: 'pas_lf',
    se_app: 'pas_se', //状态估计实时态
    se_app1: 'pas_se1', //状态估计研究态
    lf_app: 'pas_lf', //潮流分析实时态
    lf_app1: 'pas_lf1', //潮流分析研究态

    pas_app: 'pas',
    scada_app: 'scada',
    paslf_app: 'pas_lf',
    fes_app: 'fes',
    // ops_app:'pas_ops', // 吉林---华能
    ops_app: 'pas_vpp', // 吉林---华能
    vpp_app: 'pas_vpp',
    schema_name: 'jilin_cr',
    server_linkstr: import.meta.env.VITE_DATA_SERVER,
    defaultAddr: import.meta.env.VITE_DATA_SERVER,
    //defaultAddr:'http://172.16.30.236:8888',
    host_name: 'yangfan',
    login_user: '',
};

export default GlobalConfig;
